import './App.css';
import Header from './components/Header/Header';
import Main from './components/Main/Main';
import Sidebar from './components/Sidebar/Sidebar';
import Footer from './components/Footer/Footer';

function App() {
    return (
        <div>
            <Header></Header>
            <Main></Main>
            <Sidebar></Sidebar>
            <Footer></Footer>
        </div>
    );
}

export default App;
